export default "<div>{{ GetNettoyageStatut(id) }}</div>";